var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeliveryNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x9A\x9A \xEC\x9A\xB4\xEC\x86\xA1 \xED\x8A\xB8\xEB\x9F\xAD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.794 13.7004L22.4892 13.0452H15.8604V18.654H16.6812C16.677 18.5958 16.6638 18.5406 16.6638 18.4812C16.6638 17.0646 17.8122 15.9162 19.2288 15.9162C20.6454 15.9162 21.7938 17.0646 21.7938 18.4812C21.7938 18.5406 21.7806 18.5958 21.7764 18.654H22.062C22.5828 18.654 23.0052 18.2316 23.0052 17.7108V14.6544C23.0052 14.325 22.9332 13.9998 22.794 13.7004Z",
    fill: "#CBCFD2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8604 7.42923V4.88943C15.8604 4.36863 15.438 3.94623 14.9172 3.94623H1.93795C1.41715 3.94623 0.994751 4.36863 0.994751 4.88943V17.7108C0.994751 18.2316 1.41715 18.654 1.93795 18.654H2.96035C2.95615 18.5958 2.94295 18.5406 2.94295 18.4812C2.94295 17.0646 4.09135 15.9162 5.50795 15.9162C6.92455 15.9162 8.07295 17.0646 8.07295 18.4812C8.07295 18.5406 8.05975 18.5958 8.05555 18.654H15.8598L15.8604 7.42923Z",
    fill: "#4F95FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.4892 13.0452L20.3376 8.418C20.0568 7.815 19.452 7.4292 18.7872 7.4292H15.861V13.0452H22.4898H22.4892Z",
    fill: "#313D4C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.5086 15.9167C4.092 15.9167 2.9436 17.0651 2.9436 18.4817C2.9436 18.5411 2.9568 18.5963 2.961 18.6545C3.0516 19.9889 4.1514 21.0467 5.5086 21.0467C6.8658 21.0467 7.9656 19.9889 8.0562 18.6545C8.0604 18.5963 8.0736 18.5411 8.0736 18.4817C8.0736 17.0651 6.9252 15.9167 5.5086 15.9167ZM5.5086 19.5077C4.9422 19.5077 4.4826 19.0481 4.4826 18.4817C4.4826 17.9153 4.9422 17.4557 5.5086 17.4557C6.075 17.4557 6.5346 17.9153 6.5346 18.4817C6.5346 19.0481 6.075 19.5077 5.5086 19.5077Z",
    fill: "#313D4C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.2288 15.9167C17.8122 15.9167 16.6638 17.0651 16.6638 18.4817C16.6638 18.5411 16.677 18.5963 16.6812 18.6545C16.7718 19.9889 17.8716 21.0467 19.2288 21.0467C20.586 21.0467 21.6858 19.9889 21.7764 18.6545C21.7806 18.5963 21.7938 18.5411 21.7938 18.4817C21.7938 17.0651 20.6454 15.9167 19.2288 15.9167ZM19.2288 19.5077C18.6624 19.5077 18.2028 19.0481 18.2028 18.4817C18.2028 17.9153 18.6624 17.4557 19.2288 17.4557C19.7952 17.4557 20.2548 17.9153 20.2548 18.4817C20.2548 19.0481 19.7952 19.5077 19.2288 19.5077Z",
    fill: "#313D4C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.53454 18.4818C6.53454 17.9154 6.07494 17.4558 5.50854 17.4558C4.94214 17.4558 4.48254 17.9154 4.48254 18.4818C4.48254 19.0482 4.94214 19.5078 5.50854 19.5078C6.07494 19.5078 6.53454 19.0482 6.53454 18.4818Z",
    fill: "#6B7683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.2548 18.4818C20.2548 17.9154 19.7952 17.4558 19.2288 17.4558C18.6624 17.4558 18.2028 17.9154 18.2028 18.4818C18.2028 19.0482 18.6624 19.5078 19.2288 19.5078C19.7952 19.5078 20.2548 19.0482 20.2548 18.4818Z",
    fill: "#6B7683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeliveryNotice);
export default __webpack_public_path__ + "static/media/icon_delivery_notice.9c145f5993b8d4a2e3bd6202b2bcf7e6.svg";
export { ForwardRef as ReactComponent };